import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { themeStyle } from "./Components";
import { useScroll, animated } from "@react-spring/web";

export default function ScrollTop() {
  const { scrollYProgress } = useScroll();

  const handleScrollTop = () => {
    const scrollingElement =
      document.scrollingElement || document.documentElement || document.body;

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    scrollingElement.scrollTo?.({ top: 0, left: 0, behavior: "smooth" });

    window.setTimeout(() => {
      scrollingElement.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 250);
  };

  return (
    <animated.div
      role="button"
      tabIndex={0}
      aria-label="Scroll to top"
      style={{
        height: "8.75vh",
        width: "8.75vh",
        borderRadius: "40px",
        backgroundColor: themeStyle.primaryColor,
        position: "fixed",
        right: 20,
        bottom: 20,
        zIndex: 22,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        opacity: scrollYProgress,
        cursor: "pointer",
        color: "white",
      }}
      onClick={handleScrollTop}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handleScrollTop();
        }
      }}
      className="takemeup"
    >
      <ArrowUpwardIcon style={{ color: "white", fontSize: "40px" }} />
    </animated.div>
  );
}
